'use client';

import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { Box } from '@terra/ui-styled-system';
import { Checkbox } from '@terra/ui-design-system';
import { rowClickBlockerProps } from '../rowClickBlocker';

function SelectionCheckboxFrame({ children }: { children: ReactNode }) {
  return (
    <Box
      w="full"
      h="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      {...rowClickBlockerProps}
    >
      {children}
    </Box>
  );
}

export function MatchReplaceSelectAllHeader({
  checked,
  disabled,
  onCheckedChange,
}: {
  checked: boolean | 'indeterminate';
  disabled: boolean;
  onCheckedChange: (selected: boolean) => void;
}) {
  const tBulk = useTranslations('matchReplace.bulkActions');

  return (
    <SelectionCheckboxFrame>
      <Checkbox
        size="sm"
        aria-label={tBulk('selectAllRules')}
        checked={checked}
        disabled={disabled}
        onCheckedChange={(details) => onCheckedChange(details.checked === true)}
      />
    </SelectionCheckboxFrame>
  );
}

export function MatchReplaceSelectionCell({
  selected,
  onCheckedChange,
}: {
  selected: boolean;
  onCheckedChange: (selected: boolean) => void;
}) {
  const tBulk = useTranslations('matchReplace.bulkActions');

  return (
    <SelectionCheckboxFrame>
      <Checkbox
        size="sm"
        aria-label={tBulk('selectRule')}
        checked={selected}
        onCheckedChange={(details) => onCheckedChange(details.checked === true)}
      />
    </SelectionCheckboxFrame>
  );
}
